import PageLayout from '../components/layout/PageLayout'
import UserList from 'components/lists/users/UsersList'

export default function StoresPage() {
  return (
    <PageLayout pageTitle='Usuarios' pageDesc='Altas, bajas y modificaciones.'>
      <UserList/>
    </PageLayout>
  )
}